export const EVENT_NAMES = {
  // Dashboard
  REPORT_WIDGET_CLICKED: "dashboard_report_widget_clicked",
  CHANGE_DASHBOARD_CLICKED: "change_dashboard_clicked",
  CHANGE_DASHBOARD_APPLIED: "change_dashboard_applied",
  CHANGE_DASHBOARD_DATE: "change_dashboard_date",
  RESET_DASHBOARD_DATE: "reset_dashboard_date",
  // Report
  BACK_BUTTON_CLICKED: "back_button_clicked",
  FILTER_MODAL_VISIBILITY_CHANGE: "filter_modal_visibility_change",
  FILTER_KEY_CLICKED: "filter_key_clicked",
  FILTER_VALUE_CLICKED: "filter_value_clicked",
  FILTER_SAVED_BUTTON_CLICKED: "filter_saved_button_clicked",
  FILTER_KEY_REMOVE_CLICKED: "filter_key_remove_clicked",
  ADD_GROUP_BY_BUTTON_CLICKED: "add_group_by_button_clicked",
  ADD_GROUP_BY_VALUE_ITEM_CLICKED: "add_group_by_value_item_clicked",
  VISUALIZATION_BUTTON_CLICKED: "visualization_button_clicked",
  COMPARED_TO_BUTTON_CLICKED: "compared_to_button_clicked",
  VISUALIZATION_SELECTED: "visualization_selected",
  DATE_AGGREGATION_BUTTON_CLICKED: "date_aggregation_button_clicked",
  DATE_AGGREGATION_SELECTED: "date_aggregation_selected",
  CHANGE_SELECTED_DATE: "change_selected_date",
  CREATE_REPORT_CLICKED: "create_report_clicked",
  REPORT_SAVED: "report_saved",
  REPORT_DUPLICATED: "report_duplicated",
  REPORT_DOWNLOADED: "report_downloaded",
  REPORT_DELETED: "report_deleted",
  METRIC_SELECTED: "metric_selected",
}
